"use client";

import { useSearchParams } from "next/navigation";


export function useQueryParams() {
    const searchUrlParams = useSearchParams();
    return new URLSearchParams(searchUrlParams.toString());
}
